
// CSV REPORTS UI

export const METRICS_TABLE_COLUMNS = [
  { key: 'buyer', label: 'Cadena', align: 'left' },

  // OC
  { key: 'purchase_order_counts', label: 'OC Cant.', align: 'right' },
  { key: 'purchase_order_total', label: 'OC Monto', align: 'right', type: 'money' },

  // Pedidos Ubiqua
  { key: 'order_counts', label: 'Pedidos Cant.', align: 'right' },
  { key: 'order_total', label: 'Pedidos Monto', align: 'right', type: 'money' },
  {
    key: 'fill_rate_order',
    label: 'Fill Rate Pedidos',
    align: 'right',
    type: 'percent',
    tooltip: 'Líneas procesadas ÷ líneas totales de la OC'
  },
  { key: 'difference', label: 'Diferencia', align: 'right', type: 'money' },

  // ERP
  { key: 'salesorder_total', label: 'Pedidos ERP', align: 'right', type: 'money' },
  {
    key: 'fill_rate_sales',
    label: 'Fill Rate ERP',
    align: 'right',
    type: 'percent',
    tooltip: 'Líneas procesadas ERP ÷ líneas totales de la OC'
  },

  // Factura
  { key: 'invoice_total', label: 'Factura', align: 'right', type: 'money' },
  {
    key: 'fill_rate_invoice',
    label: 'Fill Rate Fact.',
    align: 'right',
    type: 'percent',
    tooltip: 'Líneas facturadas ÷ líneas totales de la OC'
  }
]

// SUMMARY REPORTS
export const SUMMARY_REPORTS_CARDS = [
  {
    key: 'received_orders',
    title: 'ÓRDENES RECIBIDAS',
    subtitle: 'Sumatoria del rango',
    icon: 'shopping_cart',
    iconFilled: true
  },
  {
    key: 'processed_orders',
    title: 'PROCESADAS',
    subtitle: 'Total generadas',
    icon: 'assignment_turned_in',
    fillRateKey: 'fill_rate_order',
    chipClass: 'oc-fill-rate-order-style'
  },
  {
    key: 'total_facturado',
    title: 'TOTAL FACTURADO',
    subtitle: 'Líneas facturadas vs OC',
    icon: 'receipt_long',
    fillRateKey: 'fill_rate_invoice',
    chipClass: 'oc-fill-rate-invoice-style',
    format: 'money'
  },
  {
    key: 'ticket_promedio',
    title: 'TICKET PROMEDIO',
    subtitle: 'Por orden facturada',
    icon: 'confirmation_number',
    format: 'money'
  }
]


// PRODUCTS NO CATEGORY

export const CATEGORY_LABELS = {
  NO_MATCH: 'Producto no encontrado',
  SIN_CATEGORIA: 'Producto sin categoría'
}
